import { render, staticRenderFns } from "./TopUpDialog.vue?vue&type=template&id=b543193e&"
import script from "./TopUpDialog.vue?vue&type=script&lang=ts&"
export * from "./TopUpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TopUpDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports